import axios from 'axios';

const http =  axios.create({
  baseURL: "https://carte-visite-backend-57d0644e5c1f.herokuapp.com/api/v1",
  // baseURL: "http://localhost:3030/api/v1",
  // TESTING
  headers: {
    "Content-type": "application/json"
  }
});

http.interceptors.request.use(
  (config) => {
      const token = sessionStorage.getItem('token');
      if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
  },
  (error) => Promise.reject(error)
);

http.interceptors.response.use(
  (response) => response,
  (error) => {
      if (error.response && error.response.status === 401) {
          sessionStorage.removeItem('token');
          window.location.href = '/login';
      }
      return Promise.reject(error);
  }
);

export default http;